import type { PaginatedList } from './common';

export type AlbumContentRegion = 'myanmar' | 'international';

export interface Album {
  albumId: string;
  name: string;
  albumType?: AlbumContentRegion;
  /** Sort order: smaller values appear first (same as public/admin album lists). */
  priority: number;
  releaseDate?: string | null;
  coverArtUrl?: string | null;
  imageUrl?: string | null;
  description?: string | null;
  musicVideoCount?: number;
  createdAt?: string;
  updatedAt?: string;
}

export type AlbumsData = PaginatedList<Album>;

export interface AlbumsQueryParams {
  page?: number;
  size?: number;
  keyword?: string;
}

export interface CreateAlbumRequest {
  name: string;
  albumType?: AlbumContentRegion;
  priority: number;
  releaseDate?: string | null;
  coverArtUrl?: string | null;
  imageUrl?: string | null;
  description?: string | null;
}

export interface UpdateAlbumRequest {
  name?: string;
  albumType?: AlbumContentRegion;
  priority: number;
  releaseDate?: string | null;
  coverArtUrl?: string | null;
  imageUrl?: string | null;
  description?: string | null;
}

/** Ascending priority, then name (matches API list ordering). */
export const compareAlbumsByPriorityThenName = (a: Album, b: Album): number => {
  const pa = a.priority ?? Number.MAX_SAFE_INTEGER;
  const pb = b.priority ?? Number.MAX_SAFE_INTEGER;
  if (pa !== pb) return pa - pb;
  return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
};

export const formatAlbumDateForDisplay = (date?: string | null): string => {
  if (!date) return 'N/A';
  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) {
    return date;
  }

  return parsedDate.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};
